import { LandslideDevelopment } from "../../../../contexts/krFormContext";
import { Option } from "../../../../components/shared/selectInput/types/selectInputProps";
import { currentYear } from "../../../../helpers/dateHelper";

export const getStartDevelopments = (developments?: LandslideDevelopment[]) => {
    return developments?.filter((dict) => {
        return dict.tyP_ZDARZENIA_SID === 1;
    }).map((value) => {
        return value.tyP_ZDARZENIA_SID as number
    });
}

export const getAgeDict = () => {
    var preparedDict = AgeDict.map((item: Option) => {
        var opt = item;
        if (item.name && item.name.slice(-1) !== "w") opt.name = item.name + " w"
        return opt;
    });
    preparedDict.reverse();
    return preparedDict;
}

export const getYearOptions = () => {
    var options: Option[] = [];
    var toYear = currentYear();
    for (var i = 1700; i < toYear + 1; i++) {
        options.push({ name: i.toString(), value: i.toString() });
    }
    options.reverse();
    return options;
}

export const getNumberOfDaysInMonth = (month: number | undefined, year: number | undefined) => {
    return new Date(year ? year : 2023, month!, 0).getDate() as number;
}

export const DateOptions: Option[] = [
    { name: "Punkt w czasie", value: "1" },
    { name: "Przed", value: "2" },
    { name: "Po", value: "3" },
    { name: "Zakres", value: "4" },
    { name: "Czas niepewny", value: "5" }
]

export const MonthOptions: Option[] = [
    { name: "1", value: "1" },
    { name: "2", value: "2" },
    { name: "3", value: "3" },
    { name: "4", value: "4" },
    { name: "5", value: "5" },
    { name: "6", value: "6" },
    { name: "7", value: "7" },
    { name: "8", value: "8" },
    { name: "9", value: "9" },
    { name: "10", value: "10" },
    { name: "11", value: "11" },
    { name: "12", value: "12" }
]

export const AgeDict: Option[] = [
    { name: "I", value: "1" },
    { name: "II", value: "2" },
    { name: "III", value: "3" },
    { name: "IV", value: "4" },
    { name: "V", value: "5" },
    { name: "VI", value: "6" },
    { name: "VII", value: "7" },
    { name: "VIII", value: "8" },
    { name: "IX", value: "9" },
    { name: "X", value: "10" },
    { name: "XI", value: "11" },
    { name: "XII", value: "12" },
    { name: "XIII", value: "13" },
    { name: "XIV", value: "14" },
    { name: "XV", value: "15" },
    { name: "XVI", value: "16" },
    { name: "XVII", value: "17" },
    { name: "XVIII", value: "18" },
    { name: "XIX", value: "19" },
    { name: "XX", value: "20" },
    { name: "XXI", value: "21" },
]
